// This file DOES NOT control the registrant report table vue app;
// it is only used to initialize the app by adding the appropriate
// script and stylesheet necessary to do so
$(function () {
	if (!!$(".registrant-report").length) {
		$(".registrant-report").each(index => {
			const container = $(".registrant-report")[index];
			const initBtn = container.querySelector(".registrant-report__init");
			const scriptSrc = container.getAttribute("data-script-src");
			const styleHref = container.getAttribute("data-stylesheet-href");
			const loader = container.querySelector(".registrant-report__loader");
			const error = container.querySelector(".registrant-report__error");

			if (!!initBtn && !!scriptSrc && !!styleHref) {
				initBtn.addEventListener("click", async (e) => {
					e.preventDefault();
					const link = document.createElement("link");
					link.rel = "stylesheet";
					link.href = styleHref;
					container.insertAdjacentElement("beforeend", link);
					loader.style.display = "block";
					initBtn.remove();

					// using a fetch request to get the script resource
					// because it allows us to check the response status
					// and handle errors accordingly
					await fetch(scriptSrc)
						.then((response) => {
							if (response.ok) {
								error.remove();
								return response.text();
							} else {
								console.error("Error retrieving script resource");
								if (response.statusText) {
									error.textContent += " - Status: " + response.statusText;
								}
								loader.remove();
								error.style.display = "block";
								return;
							}
						})
						.then((data) => {
							const script = document.createElement("script");
							script.innerHTML = data;
							container.insertAdjacentElement("beforeend", script);
							loader.remove();
						});
				});
			}
			else {
				loader.remove();
				initBtn.remove();
				error.style.display = "block";
			}
		});
	}
});
